import React, { Component } from 'react';
import { BrowserRouter as Router, Route } from 'react-router-dom';
import ScrollToTop from './components/ScrollToTop';
import { Provider } from 'react-redux';
import { createStore } from 'redux';
import './App.css';
import reducers from './reducers';


import Splash from './screens/Splash';


class App extends Component {
  // constructor(props) {
  //   super(props);
  //   var config = {
  //     apiKey: "AIztXWE",
  //     authDomain: "avcom",
  //     databaseURL: "httom",
  //     projectId: "a",
  //     storageBucket: "a",
  //     messagingSenderId: ""
  //   };
  //   firebase.initializeApp(config);
  // }

  render() {
    const store = createStore(reducers, {});

    return (
      <Provider store={store}>
        <Router onUpdate={() => window.scrollTo(0, 0)}>
          <div>
            <ScrollToTop />
            <Route path="/" exact component={Splash} />
            {/* <Route path="/" exact component={Splash} />
            <Route path="/login" exact component={Login} /> */}

            {/* <Route path="/job" exact component={AddJob} />
            <Route path="/job/:jobId" exact component={AddJob} /> */}
          </div>
        </Router>
      </Provider>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js